<!--<div class="relative flex w-full items-center justify-center">-->
<!--    @if(showArrowLeft()) {-->
<!--      <button-->
<!--        class="hidden sm:block w-8 h-8 -translate-y-[32.5px] items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2] sm:mr-[5px]"-->
<!--        data-svg-wrapper-->
<!--        (click)="LeftButtonClicked()"-->
<!--      >-->
<!--        <ln-chevron-left-svg-icon [class]="'w-8 h-8'"></ln-chevron-left-svg-icon>-->
<!--      </button>-->
<!--    } @else {-->
<!--      <button class="hidden sm:block sm:mr-[5px] w-8 h-8"> </button>-->
<!--    }-->
<!--  <div-->
<!--    class="flex gap-[15px] sm:gap-[42px] overflow-x-scroll scroll-smooth no-scrollbar"-->
<!--    #carrouselNativeElement-->
<!--  >-->
<!--    @for(product of products(); track $index) {-->
<!--        <ln-main-product-card #carrouselNativeElementItem [product]="product" [showPrice]="showProductsPrice"></ln-main-product-card>-->
<!--    }-->
<!--  </div>-->
<!--    @if(showArrowRight()) {-->
<!--      <button-->
<!--        class="hidden sm:block w-8 h-8 -translate-y-[32.5px] items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2] sm:ml-[5px]"-->
<!--        data-svg-wrapper-->
<!--        (click)="RightButtonClicked()"-->
<!--      >-->
<!--        <ln-chevron-right-svg-icon [class]="'w-8 h-8'"></ln-chevron-right-svg-icon>-->
<!--      </button>-->
<!--    } @else {-->
<!--  <button class="hidden sm:block sm:ml-[5px] w-8 h-8"> </button>-->
<!--  }-->
<!--  @if(showArrowLeft()) {-->
<!--          <button-->
<!--            class="block sm:hidden absolute left-0 -translate-x-1/2 -translate-y-[32.5px] w-[37px] h-[37px] items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2] sm:mr-[5px]"-->
<!--            data-svg-wrapper-->
<!--            (click)="LeftButtonClicked()"-->
<!--          >-->
<!--            <ln-chevron-left-svg-icon [class]="'w-8 h-8'"></ln-chevron-left-svg-icon>-->
<!--          </button>-->
<!--  }-->
<!--  @if(showArrowRight()) {-->
<!--    <button-->
<!--      class="block sm:hidden absolute right-0 translate-x-1/2 -translate-y-[32.5px] w-[37px] h-[37px] items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2]"-->
<!--      data-svg-wrapper-->
<!--      (click)="RightButtonClicked()"-->
<!--    >-->
<!--      <ln-chevron-right-svg-icon [class]="'w-8 h-8'"></ln-chevron-right-svg-icon>-->
<!--    </button>-->
<!--  }-->
<!--</div>-->
<div class="relative flex w-full items-center justify-center">
  @if(showArrowLeft()) {
    <button
      class="hidden sm:block w-8 h-8 -translate-y-[32.5px] items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2] sm:mr-[5px]"
      data-svg-wrapper
      (click)="LeftButtonClicked()"
    >
      <ln-chevron-left-svg-icon [class]="'w-8 h-8'"></ln-chevron-left-svg-icon>
    </button>
  } @else {
    <button class="hidden sm:block sm:mr-[5px] w-8 h-8"> </button>
  }
  <div
    class="flex gap-[15px] sm:gap-[42px] overflow-x-scroll scroll-smooth no-scrollbar"
    #carrouselNativeElement
  >
    @for(product of products(); track $index) {
      <ln-main-product-card #carrouselNativeElementItem [product]="product" [showPrice]="showProductsPrice"></ln-main-product-card>
    }
  </div>
  @if(showArrowRight()) {
    <button
      class="hidden sm:block w-8 h-8 -translate-y-[32.5px] items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2] sm:ml-[5px]"
      data-svg-wrapper
      (click)="RightButtonClicked()"
    >
      <ln-chevron-right-svg-icon [class]="'w-8 h-8'"></ln-chevron-right-svg-icon>
    </button>
  } @else {
    <button class="hidden sm:block sm:ml-[5px] w-8 h-8]"> </button>
  }
  @if(showArrowLeft()) {
    <button
      class="block sm:hidden absolute left-0 -translate-x-1/2 -translate-y-[32.5px] w-8 h-8 items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2] sm:mr-[5px]"
      data-svg-wrapper
      (click)="LeftButtonClicked()"
    >
      <ln-chevron-left-svg-icon [class]="'w-8 h-8'"></ln-chevron-left-svg-icon>
    </button>
  }
  @if(showArrowRight()) {
    <button
      class="block sm:hidden absolute right-0 translate-x-1/2 -translate-y-[32.5px] w-8 h-8 items-center justify-center hover:cursor-pointer rounded-full bg-white hover:bg-[#F2F2F2]"
      data-svg-wrapper
      (click)="RightButtonClicked()"
    >
      <ln-chevron-right-svg-icon [class]="'w-8 h-8'"></ln-chevron-right-svg-icon>
    </button>
  }
</div>
